import React, { FC, useMemo } from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';

import Select, { SimpleOption } from 'vibo-ui/Select';

import { getEventStatusByFilter } from 'services/events/helpers';
import { useEventsFilterable } from '../../../EventsListContext';

import { SessionStorageKeys } from 'types/enums';

import useStyles from '../../style';

const StatusColumn: FC<ColumnProps> = ({ data = [] }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { filter, setFilter } = useEventsFilterable();

  const statusId = getEventStatusByFilter(filter);

  const options = useMemo(
    () =>
      data.map(option => ({
        label: t(option.title),
        ...option,
      })),
    [data]
  );

  const handleChange = ({ value }: SimpleOption) => {
    sessionStorage.setItem(SessionStorageKeys.ehStatus, value);

    setFilter((prev: EventsFilter) => ({
      ...prev,
      past: value === 'past',
      isDeleted: value === 'isDeleted',
    }));
  };

  return (
    <div className="statusColumn">
      <span className="label">{t('status')}</span>
      <Select
        value={statusId}
        onChange={handleChange}
        components={{
          Option: props => {
            const data = get(props, 'data') as { color: string };

            return (
              <Select.Option {...props}>
                <div className={classes.dot} style={{ backgroundColor: data.color }} />
                {props.label}
              </Select.Option>
            );
          },
        }}
        options={options}
        styleModificator="asLink"
        hideDropdownIndicator
        menuShouldBlockScroll
      />
    </div>
  );
};

export default StatusColumn;
